import gql from 'graphql-tag';

export default gql`
    mutation AllocateBox($input: AllocateBoxInput) {
        allocateBox(input: $input) {
            errors
        }
    }
`;
